import { Component, ViewChild, ViewContainerRef, AfterViewInit, ViewChildren, AfterViewChecked } from '@angular/core';

import { ICellEditorAngularComp } from 'ag-grid-angular';
  
  @Component({
    selector: 'numeric-cell',
    template: `
      <input
        #input
        viasOnlyNumeric
        (keydown)="onKeyDown($event)"
        [(ngModel)]="value"
        style="width: 100%"
      />
    `,
  })
  export class EditorDecimalNumericComponent implements ICellEditorAngularComp, AfterViewInit {
    private params: any;
    public value: number;
    private cancelBeforeStart: boolean = false;
  
    @ViewChild('input', { read: ViewContainerRef , static : true }) public input;
  
    agInit(params: any): void {
      this.params = params;
      this.value = this.params.value;
      // only start edit if key pressed is a number, not a letter
      this.cancelBeforeStart =
        params.charPress && '1234567890'.indexOf(params.charPress) < 0;
    }
  
    getValue(): any {
      return this.value;
    }
  
    isCancelBeforeStart(): boolean {
      return this.cancelBeforeStart;
    }
  
    // will reject the number if it greater than 1,000,000
    // not very practical, but demonstrates the method.
    isCancelAfterEnd(): boolean {
      return this.value > 1000000;
    }
  
    onKeyDown(event): void {
      if (!this.isKeyPressedNumeric(event)) {
        if (event.defaultPrevented) event.preventDefault();
      }
    }
  
    // dont use afterGuiAttached for post gui events - hook into ngAfterViewInit instead for this
    ngAfterViewInit() {
      window.setTimeout(() => {
        this.input.element.nativeElement.focus();
      });
    }
  
    private getCharCodeFromEvent(event): any {
      event = event || window.event;
      return typeof event.which == 'undefined' ? event.keyCode : event.which;
    }
  
    private isCharNumeric(charStr): boolean {
      var regex = new RegExp(/^[0-9]+(.[0-9]*){0,1}$/g);
      return regex.test(charStr);
    }
  
    private isKeyPressedNumeric(event): boolean {
      const charCode = this.getCharCodeFromEvent(event);
      const charStr = event.key ? event.key : String.fromCharCode(charCode);
      return charStr;
    }
  }